const Reflux = require("reflux");
const NewDealsActions = require("../actions/new-deals-actions");

const NewDealsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      count: 0,
      amount: 0,
      countDelta: 0,
      amountDelta: 0,
    }
  },

  init: function() {
    this.listenTo(NewDealsActions.fetchData, this.onFetchStarted);
    this.listenTo(NewDealsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(NewDealsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        count: data.count.value,
        amount: data.total_amount.value,
        countDelta: data.count.delta,
        amountDelta: data.total_amount.delta
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = NewDealsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/new-deals-store.js